module.exports = __webpack_public_path__ + "img/fm-whatsapp-cover.256178ce.png";